// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.7618 8.5L12 1.91406L9.23816 8.5H14.7618Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.6006 10.5H8.39945L6.83493 14.2308H17.1651L15.6006 10.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.0038 16.2308H5.99622L4.83498 18.9999H3V20.9999H21V18.9999H19.165L18.0038 16.2308Z"}}]};

const TrafficEventsFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'traffic-events-filled',
    ref,
    icon: element,
  },
));

TrafficEventsFilledIcon.displayName = 'TrafficEventsFilledIcon';

export default TrafficEventsFilledIcon;
